import { render, staticRenderFns } from "./cp_config_list.vue?vue&type=template&id=11fdda10&"
import script from "./cp_config_list.vue?vue&type=script&lang=js&"
export * from "./cp_config_list.vue?vue&type=script&lang=js&"
import style0 from "./cp_config_list.vue?vue&type=style&index=0&id=11fdda10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports